export default __webpack_public_path__ + "static/media/birthdayBg.4de6c409.jpg";